const listDefaultStyle = (theme, square) => ({
  color: `${theme.tokens.ComponentListItemsFontColor}`,
  fontSize: `${theme.tokens.ComponentListItemsFontSize}`,
  fontFamily: `${theme.tokens.ComponentListItemsFontFamily}`,
  '.ids-list-items-container > div': {
    marginBottom: '-1px',
    caretColor: 'transparent',
    ...(square ? {
      '&.ids-list-group-item:last-child': {
        marginBottom: 0
      }
    } : {
      '&.ids-list-group-item:last-child': {
        marginBottom: 0
      },
      '&.ids-list-group-item.ids-list-group-item-selected': {
        marginBottom: 0
      },
      '&.ids-list-group-item.ids-list-group-item-selected + .ids-list-group-item .ids-list-item-content': {
        borderTop: 'none'
      },
      '&.ids-list-group-item:first-of-type .ids-list-item-content': {
        borderTopRightRadius: `${theme.tokens.ComponentListItemBorderRadius}`
      },
      '&.ids-list-group-item:last-child .ids-list-item-content': {
        borderBottomRightRadius: `${theme.tokens.ComponentListItemBorderRadius}`
      },
      '&.ids-list-group-item:first-of-type:not(.ids-list-group-item-selected) .ids-list-item-content': {
        borderTopLeftRadius: `${theme.tokens.ComponentListItemBorderRadius}`
      },
      '&.ids-list-group-item:last-child:not(.ids-list-group-item-selected) .ids-list-item-content': {
        borderBottomLeftRadius: `${theme.tokens.ComponentListItemBorderRadius}`
      },
      '&.ids-list-group-item:first-of-type.ids-list-group-item-selected .ids-list-item-content-selected': {
        borderTopLeftRadius: `${theme.tokens.ComponentListItemBorderRadius}`
      },
      '&.ids-list-group-item:last-child.ids-list-group-item-selected .ids-list-item-content-selected': {
        borderBottomLeftRadius: `${theme.tokens.ComponentListItemBorderRadius}`
      }
    })
  }
});
export default listDefaultStyle;